import styled from "styled-components";

export const StyledFooter = styled.div`
  position: absolute;
  bottom: -67px;
  width: 100vw;
  padding: 40px 40px 40px 30px;
  background-color: #f1f1f1;
  height: 269px;
  left: 0;
  right: 0;

  @media (max-width: 900px) {
    height: 500px;
    padding: 36px 16px 24px;
    /* box-sizing: content-box; */
  }

  .Logo-footer {
    margin-bottom: 34px;
    height: 30px;
    @media (max-width: 900px) {
      margin-bottom: 0;
    }
  }

  .contacts {
    display: flex;
    flex-direction: column;
    width: fit-content;
    align-items: flex-start;

    @media (max-width: 900px) {
      flex-direction: column;
      align-items: unset;
    }

    img {
      height: 30px;
      margin-right: 45px;

      @media (max-width: 900px) {
        margin-bottom: 0;
      }
    }
  }

  .box {
    @media (max-width: 900px) {
      margin: 8px 0;
      margin-bottom: 0;
    }
  }

  .contact {
    font-size: 14px;
    color: #131b1f;
    font-weight: 600;
    margin: 24px 0;
    display: flex;
    align-items: center;

    @media (max-width: 900px) {
      margin: 16px 0;
    }

    svg {
      font-size: 18px;
      margin-right: 12px;
    }

    .phone {
      font-size: 23px;
      margin-left: -3px;
    }
  }

  .text {
    cursor: pointer;
    margin: 24px 0;
    font-weight: 600;

    @media (max-width: 900px) {
      margin: 16px 0;
    }
  }

  .social {
    display: flex;
    margin-top: 34px;

    @media (max-width: 900px) {
      margin-top: 24px;
      margin-bottom: 24px;
    }

    svg {
      margin-right: 32px;
      font-size: 20px;

      @media (max-width: 900px) {
        margin-right: 19px;
        font-size: 18px;
      }
    }

    a {
      width: fit-content;
      height: fit-content;
      align-items: baseline;
      display: flex;
    }
  }

  .powered {
    color: #5a5f62;
    font-size: 14px;
    font-weight: 500;
    margin: 0;
    line-height: 16px;

    svg {
      width: 80px;
      margin-left: 6px;
    }
  }

  .apk-row {
    margin-bottom: 25px;
    flex-direction: column;
    display: flex;
    align-items: flex-end;

    @media (max-width: 900px) {
      flex-direction: row;
      margin-top: 8px;
      margin-bottom: 24px;

      &::-webkit-scrollbar {
        display: none;
      }
    }
  }

  .apk-download-icon {
    width: 123px;
    height: 34px;
    margin-bottom: 8px;
    cursor: pointer;

    @media (max-width: 900px) {
      margin-bottom: 0;
    }

    svg {
      width: 123px;
      height: 34px;
    }

    &--apk {
      /* width: 125.2px;
      @media (max-width: 900px) {
        width: 95.4px;
      } */
    }

    &--play {
      /* width: 139.6px;
      @media (max-width: 900px) {
        width: 109.3px;
      } */
    }

    &--app-store {
      /* width: 122px;
      @media (max-width: 900px) {
        width: 98.2px;
      } */
    }
  }

  .hr {
    margin-bottom: 24px;
    margin-top: 0;
  }

  .layout {
    display: grid;
    grid-template-columns: auto auto auto auto;
    padding-bottom: 24px;

    @media (max-width: 900px) {
      grid-template-columns: auto;
      padding-bottom: 0;
    }
  }
`;
